import CustomCard from 'components/card/CustomCard'
import CustomCardHeader from 'components/card/CustomCardHeader'
import CardBody from 'components/card/CardBody'
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CustomTable, {
  TableHeader,
  TableRow,
} from 'components/table/CustomTable'
import { SemiTransparentButton } from 'components/CustomButton'
import NotificationList from './NotificationList'
import {
  notificationGroup,
  notificationTypeOptions,
  scheduleFilters,
  statusFilters,
  bulkNotificationTypeOptions,
} from '../constants'
import { setNotificationTab } from 'redux/slices/notificationSlice'
import LabeledSelect from 'components/selects/LabeledSelect'
import { tryFetchScheduledNotification } from 'redux/slices/notificationSlice'
import CustomTableItemLoader from 'components/CustomTableItemLoader'
import ConfirmModal from 'components/ConfirmModal'
import ProductPreview from './ProductPreviewModal'
import { tryDeleteScheduledNotification } from 'redux/slices/notificationSlice'
import { setRedirect } from 'redux/slices/notificationSlice'
import CardFooter from 'components/card/CardFooter'
import { CommonTabGroup } from 'components/tab/TabGroup'
import TabGroup from 'components/tab/TabGroup'
import CustomTab from 'components/tab/CustomTab'
import Pagination from 'components/Pagination'
import { tryFetchBulkNotification } from 'redux/slices/notificationSlice'
import { setNotificationGroup } from 'redux/slices/notificationSlice'
import { resetNotification } from 'redux/slices/notificationSlice'

const NotificationTable = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [filters, setFilters] = useState({
    status: statusFilters[0],
    schedule: scheduleFilters[0],
  })

  const [showModal, setShowModal] = useState()
  const [deleteModal, setDeleteModal] = useState()

  const {
    selectedTab: activeTab,
    selectedGroup: activeGroup,
    scheduled,
    processing,
    redirect,
  } = useSelector((state) => state.notification)

  useEffect(() => {
    if (redirect) dispatch(setRedirect(false))
  }, [redirect])

  useEffect(() => {
    setDeleteModal(false)
  }, [scheduled])

  const isRecurring = activeGroup.value === notificationGroup[0].value

  const Tab = ({ tab }) => {
    return (
      <div
        className={`${activeTab === tab
            ? 'text-rand-100 border-secondary-500'
            : 'text-rand-200 border-transparent hover:border-rand-300 cursor-pointer'
          } focus:outline-none px-6 py-3 text-sm font-medium border-b-2`}
        onClick={() => {
          if (activeTab !== tab) {
            dispatch(setNotificationTab(tab))
            if (activeGroup.value === notificationGroup[0].value) {
              fetchScheduledNotification(tab)
            } else {
              fetchBulkNotification(tab)
            }
          }
        }}
      >
        {tab.label}
      </div>
    )
  }

  useEffect(() => {
    return () => {
      dispatch(resetNotification())
    }
  }, [])

  useEffect(() => {
    fetchByNotificationGroup(activeGroup, activeTab)
  }, [filters])

  const fetchByNotificationGroup = (selectedGroup, tab, page = 1) => {
    if (selectedGroup.value === notificationGroup[0].value) {
      fetchScheduledNotification(tab, page)
    } else {
      fetchBulkNotification(tab, page)
    }
  }

  const fetchScheduledNotification = (tab, page = 1) => {
    dispatch(
      tryFetchScheduledNotification({
        page: page,
        type: filters.schedule?.value === 'ALL' ? '' : filters.schedule.value,
        status: filters.status.value === 'ALL' ? '' : filters.status.value,
        notification_type: (tab ?? activeTab).value,
      }),
    )
  }

  const fetchBulkNotification = (tab, page = 1) => {
    dispatch(
      tryFetchBulkNotification({
        page: page,
        notification_type: (tab ?? activeTab).value,
      }),
    )
  }

  const deleteNotification = () => {
    dispatch(tryDeleteScheduledNotification(deleteModal.id))
  }

  const handlePageClick = (data) => {
    let currentPage = data.selected + 1
    if (currentPage !== scheduled.page)
      // fetchScheduledNotification(activeTab, currentPage)
      fetchByNotificationGroup(activeGroup, activeTab, currentPage)
  }

  const NotificationGroupTab = ({ tab }) => {
    return (
      <div
        className={`${activeGroup.value === tab.value
            ? 'cursor-default'
            : 'text-gray-200 cursor-pointer'
          } px-1 h-full text-center text-base relative group mr-2 flex items-center justify-center min-w-[90px]`}
        onClick={() => {
          dispatch(setNotificationGroup(tab))
          const selected =
            tab.value === notificationGroup[0].value
              ? notificationTypeOptions[0]
              : bulkNotificationTypeOptions[0]
          fetchByNotificationGroup(tab, selected)
          dispatch(setNotificationTab(selected))
        }}
      >
        {tab.label}
        <div className={`absolute left-0 right-0 bottom-0 h-[4px] rounded-tl rounded-tr${activeGroup.value === tab.value
            ? ' bg-rand-100'
            : ' group-hover:bg-gray-100'
          }`}/>
      </div>
    )
  }

  return (
    <>
      <CustomCard>
        <CustomCardHeader color="blue" contentPosition="none" className="pd-y-0">
          <div className="flex items-center justify-between w-full h-full">
            <div className="inline-flex overflow-hidden h-full">
              {notificationGroup.map((n) => (
                <NotificationGroupTab tab={n} key={n.value} />
              ))}
            </div>
            <SemiTransparentButton
              onClick={() => {
                activeGroup.value === notificationGroup[0].value ?
                navigate(`/notification/schedule/form`):
                navigate(`/notification/bulk/form`)
              }}>
              + {activeGroup.value === notificationGroup[0].value ? "Schedule" : "Send"} New Notification
            </SemiTransparentButton>
          </div>
        </CustomCardHeader>
        <CardBody>
          <CommonTabGroup>
            {(activeGroup.value === notificationGroup[0].value
              ? notificationTypeOptions
              : bulkNotificationTypeOptions
            ).map((n, index) => (
              <Tab key={`${n}-${index}`} tab={n} />
            ))}
          </CommonTabGroup>
          {activeGroup.value === notificationGroup[0].value && (
            <div className="flex space-x-5">
              <TabGroup extClass="mb-6">
                {scheduleFilters.map((v, index) => (
                  <CustomTab
                    className="py-3 flex-1 whitespace-nowrap px-9"
                    active={v.value === filters.schedule.value}
                    onClick={() => {
                      setFilters({
                        ...filters,
                        schedule: v,
                      })
                    }}
                    key={`schedule-${index}`}
                  >
                    {v.label}
                  </CustomTab>
                ))}
              </TabGroup>

              <div className="w-60">
                <LabeledSelect
                  options={statusFilters}
                  value={filters.status}
                  onChange={(filter) => {
                    setFilters({
                      ...filters,
                      status: filter,
                    })
                  }}
                  placeholder="Select Status Type"
                />
              </div>
            </div>
          )}

          <div className="overflow-x-auto">
            <CustomTable>
              <thead>
                <TableRow>
                  <TableHeader>Notification</TableHeader>
                  {isRecurring && <TableHeader>Type</TableHeader>}
                  <TableHeader>
                    {!isRecurring ? 'Sent At' : 'Date & Time'}
                  </TableHeader>
                  <TableHeader>Status</TableHeader>
                  <TableHeader>Target</TableHeader>
                  <TableHeader />
                </TableRow>
              </thead>
              {scheduled.loading ||
                scheduled.error ||
                scheduled.data.length === 0 ? (
                <CustomTableItemLoader
                  loading={scheduled.loading}
                  error={scheduled.error}
                  isEmpty={true}
                  count={10}
                  colSpan={6}
                  key="notification-scheduled"
                  retry={() => fetchScheduledNotification(activeTab)}
                  emptyStateMessage= "No Notifications"
                  emptyStateIcon= "notifications"
                />
              ) : (
                <tbody>
                  <NotificationList
                    showModal={showModal}
                    setShowModal={setShowModal}
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    isRecurring={isRecurring}
                  />
                </tbody>
              )}
            </CustomTable>
          </div>
        </CardBody>
        {!(scheduled.loading || scheduled.error.length > 0 || scheduled.data.length === 0) && (
          <CardFooter>
            <Pagination
              pageCount={scheduled?.totalPage}
              onPageChange={handlePageClick}
              forcePage={scheduled.page - 1}
            />
          </CardFooter>
        )}
        {!!showModal && (
          <ProductPreview showModal={showModal} setShowModal={setShowModal} />
        )}
        {/*confirmation dialog modal*/}
        <ConfirmModal
          title="Remove Notification"
          children="Are you sure you want to remove this notification?"
          showModal={!!deleteModal}
          setShowModal={() => setDeleteModal(undefined)}
          disabled={processing}
          onConfirm={deleteNotification}
        />
      </CustomCard>
    </>
  )
}

export default NotificationTable
